import { render, staticRenderFns } from "./TraderComplementModal.vue?vue&type=template&id=61805180&scoped=true&"
import script from "./TraderComplementModal.vue?vue&type=script&lang=js&"
export * from "./TraderComplementModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61805180",
  null
  
)

export default component.exports